import { generateUtilityClass, generateUtilityClasses } from "@mui/core";
export function getInfoUtilityClass(slot) {
  return generateUtilityClass("JunInfo", slot);
}
export var infoClasses = generateUtilityClasses("JunInfo", ["root", "title", "subtitle", "caption", "eyebrow"]);